/* eslint-disable react-hooks/rules-of-hooks */
import Image from "next/image";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { Upcoming } from "@mui/icons-material";
import { Box, Typography, Button, Chip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CancelIcon from "@mui/icons-material/Cancel";
import PaymentsIcon from '@mui/icons-material/Payments';
import TimerIcon from '@mui/icons-material/Timer';
import ContactlessIcon from '@mui/icons-material/Contactless';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import TripCard from "../../../../components/GuestBooking/TripCard";

const Properties = ({ bookingData, setRating, handleOpenRating, rating, dataFilter, setDataFilter, setLoading, loading, currentPage, activeTab, dataOne, handleViewDetails }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (activeTab === 0) {
    if (bookingData?.detail?.upcoming.length === 0) {
      return (
        <div className="text-center">
          <Image
            width={300}
            height={300}
            className="rounded-4 col-12 js-lazy"
            // src={`/img/hotels/1.png`}
            src="/img/general/nodata.png"
            alt="image"
            style={{
              width: '200px',
            }}
          />
          <h4 className="text-center">No Booking</h4>
        </div>
      );
    }
  } else {
    if (bookingData?.detail?.history.length === 0) {
      return (
        <div className="text-center">
          <Image
            width={300}
            height={300}
            className="rounded-4 col-12 js-lazy"
            // src={`/img/hotels/1.png`}
            src="/img/general/nodata.png"
            alt="image"
            style={{
              width: '200px',
            }}
          />
          <h4 className="text-center">No Booking</h4>
        </div>
      );
    }
  }

  const handleRatingClick = (newRating, index, id, type) => {
    setCurrentIndex(index);
    setDataFilter({ ...dataFilter, ['bookingId']: id, ['type']: type, ['rating']: newRating });
    setRating(newRating);
    handleOpenRating();
  };


  return (
    <>
      {activeTab === 0 ? bookingData?.detail?.upcoming.slice(0, 50).map((item, index) => (
        <div key={index} className="pl-0 pr-0">
          <TripCard
            trip={{
              id: item?.tripId,
              time: moment(item?.pickedTime).format("YYYY-MM-DD hh:mm A"),
              location: item?.place,
              amount: item?.showFare ? item?.approx_fare : undefined,
              status: item.status,
              travelStatus: item.travelStatus,
            }}
          />
          {/* <div className="col-12" key={item.tripId} style={{
          backgroundColor: '#d9d9d92b',
          marginBottom: '12px'
        }}>
          <div className="row x-gap-20 y-gap-30">            
            <div className="col-md">
              <h3 className="text-18 lh-14 fw-500">
                {item?.modelName}
              </h3>

              <div className="row x-gap-10 y-gap-10 items-center pt-20">
                <Grid container spacing={2}>
                  <Grid item xs={12} key={index}>                    
                    <div className="col-auto d-flex align-items-center gap-2">
                      <LocationOnIcon
                        fontSize="small"
                        sx={{ color: "#4A4A4A" }} // or any color you want
                      />

                      <h3 className="text-18 lh-14 fw-500 mb-0">
                        {item?.place}
                        {item?.isExpired && (
                          <Chip
                            label="Expired"
                            color="error"
                            size="small"
                            component="span"
                            sx={{ fontWeight: 500, ml: 1 }}
                          />
                        )}
                      </h3>
                    </div>
                  </Grid>
                  <Grid item xs={6} key={index}>
                    <div className="d-flex align-items-center gap-2">
                      <WatchLaterIcon fontSize="small" color="dark-3" />
                      <h3 className="text-18 lh-14 fw-500">
                        {item?.displayPickedTime ?? "-"}
                      </h3>
                    </div>
                  </Grid>
                  {
                    item?.isPersonalChauffeur &&
                    <>
                      <Grid item xs={6} key={index}>
                        <div className="d-flex align-items-center gap-2">
                          <EmojiTransportationIcon fontSize="medium" color="dark-3" />
                          <h3 className="text-18 lh-14 fw-500">
                            {item?.bookingType ?? "-"}
                          </h3>
                        </div>
                      </Grid>
                    </>
                  }
                  {
                    item?.isHourly &&
                    <>
                      <Grid item xs={6} key={index}>
                        <div className="d-flex align-items-center gap-2">
                          <TimerIcon fontSize="small" color="dark-3" />
                          <h3 className="text-18 lh-14 fw-500">
                            {item?.bookingType ?? "-"}
                          </h3>
                        </div>
                      </Grid>
                      <Grid item xs={6} key={index}>
                        <div className="d-flex align-items-center gap-2">
                          <PaymentsIcon fontSize="small" color="dark-3" />
                          <h3 className="text-18 lh-14 fw-500">
                            {item?.paymentType ?? "-"}
                          </h3>
                        </div>
                      </Grid>
                      <Grid item xs={6} key={index}>
                        <div className="d-flex align-items-center gap-2">
                          <ContactlessIcon fontSize="small" color="dark-3" />
                          <h3 className="text-18 lh-14 fw-500">
                            {item?.paymentStatus ?? "-"}
                          </h3>
                        </div>
                      </Grid>
                    </>
                  }

                </Grid>

              </div>
            
              <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                {
                  item.travelStatus === 0 ? (
                    <Chip label="Trip Created" color="info" sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 1 ? (
                    <Chip label="Trip Completed" color="success" sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 2 ? (
                    <Chip label="Trip Inprogress" color="primary" sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 3 ? (
                    <Chip label="Driver Arrived" color="info" sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 4 ? (
                    <Chip label="Cancelled by Passenger" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 5 ? (
                    <Chip label="Trip Confirmed" color="primary" sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 6 ? (
                    <Chip label="Passenger Cancelled" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 8 ? (
                    <Chip label="Cancelled by Dispatcher" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 9 ? (
                    <Chip label="Trip Confirmed" color="primary" sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 12 ? (
                    <Chip label="Driver on the Way" color="info" sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 13 ? (
                    <Chip label="Driver Cancelled" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                  ) : item.travelStatus === 16 ? (
                    <Chip label="Waiting For Approver Confirmation" color="warning" sx={{ fontWeight: 500 }} />
                  ) : (
                    <Chip label="Pending" color="default" sx={{ fontWeight: 500 }} />
                  )
                }
                
                {item.status === "Completed" && (
                  <Button
                    variant="contained"
                    startIcon={<WhatsAppIcon />}
                    sx={{
                      backgroundColor: "#25D366",
                      color: "white",
                      textTransform: "none",
                      borderRadius: "20px",
                      "&:hover": { backgroundColor: "#1EBE5D" },
                    }}
                  >
                    Chat
                  </Button>
                )}
              </Box>
            </div>
            
            <div className="col-md-auto text-right md:text-left">
              <div className="d-flex flex-column justify-between h-full">
                <div className="row x-gap-10 y-gap-10 justify-end items-center md:justify-start">
                  <Typography variant="body2" className="fw-500">
                    Trip ID
                  </Typography>
                  <Typography variant="h6" className="fw-500 text-dark-3">
                    {item?.tripId}
                  </Typography>
                </div>

                {
                  item?.showFare &&
                  <div className="pt-24">
                    <Typography variant="body2" className="fw-500">
                      Amount
                    </Typography>
                    <Typography variant="h6" className="fw-500 text-dark-3">
                      AED {item?.approx_fare}
                    </Typography>
                  </div>
                }

              </div>
            </div>
          </div>

        </div> */}
        </div>
      )) :
        bookingData?.detail?.history.slice(0, 50).map((item, index) => (
          <div key={index} className="pl-0 pr-0">
            <TripCard
              trip={{
                id: item?.tripId,
                time: moment(item?.pickedTime).format("YYYY-MM-DD hh:mm A"),
                location: item?.place,
                amount: item?.showFare ? item?.approx_fare : undefined,
                status: item.status,
                travelStatus: item.travelStatus,
              }}
            />

            {/* <div className="col-12" key={item.tripId}>
              <div className="row x-gap-20 y-gap-30">
                <div className="col-md">
                  <Typography variant="h6" className="text-18 lh-14 fw-500">
                    {item?.modelName}
                  </Typography>

                  <div className="row x-gap-10 y-gap-10 items-center pt-20">
                    <div className="col-auto d-flex align-items-center gap-2">
                      <LocationOnIcon fontSize="small" className="bg-dark-3" />
                      <Typography variant="body2" className="text-14" style={{ width: "500px" }}>
                        {item?.place}
                      </Typography>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <AccessTimeIcon fontSize="small" color="primary" />
                      <Typography variant="body2" className="fw-500 text-blue-1">
                        {moment(item?.pickedTime).format("YYYY-MM-DD hh:mm A")}
                      </Typography>
                    </div>
                  </div>

                  <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                    {
                      item.travelStatus === 0 ? (
                        <Chip label="Trip Created" color="info" sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 1 ? (
                        <Chip label="Trip Completed" color="success" sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 2 ? (
                        <Chip label="Trip Inprogress" color="primary" sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 3 ? (
                        <Chip label="Driver Arrived" color="info" sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 4 ? (
                        <Chip label="Cancelled by Passenger" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 5 ? (
                        <Chip label="Trip Confirmed" color="primary" sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 6 ? (
                        <Chip label="Passenger Cancelled" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 8 ? (
                        <Chip label="Cancelled by Dispatcher" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 9 ? (
                        <Chip label="Trip Confirmed" color="primary" sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 12 ? (
                        <Chip label="Driver on the Way" color="info" sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 13 ? (
                        <Chip label="Driver Cancelled" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                      ) : item.travelStatus === 16 ? (
                        <Chip label="Waiting For Approver Confirmation" color="warning" sx={{ fontWeight: 500 }} />
                      ) : (
                        <Chip label="Pending" color="default" sx={{ fontWeight: 500 }} />
                      )
                    }

                    {item.status === "Completed" && (
                      <Button
                        variant="contained"
                        startIcon={<WhatsAppIcon />}
                        sx={{
                          backgroundColor: "#25D366",
                          color: "white",
                          textTransform: "none",
                          borderRadius: "20px",
                          "&:hover": { backgroundColor: "#1EBE5D" },
                        }}
                      >
                        Chat
                      </Button>
                    )}
                  </Box>
                </div>

                <div className="col-md-auto text-right md:text-left">
                  <div className="d-flex flex-column justify-between h-full">
                    <div className="row x-gap-10 y-gap-10 justify-end items-center md:justify-start">
                      <Typography variant="body2" className="fw-500">
                        Trip ID
                      </Typography>
                      <Typography variant="h6" className="fw-500 bg-dark-3">
                        {item?.tripId}
                      </Typography>
                    </div>

                    {
                      item?.showFare &&
                      <div className="pt-24">
                        <Typography variant="body2" className="fw-500">
                          Amount
                        </Typography>
                        <Typography variant="h6" className="fw-500 text-dark-3">
                          AED {item?.approx_fare}
                        </Typography>
                      </div>
                    }
                  </div>
                </div>
              </div>


            </div> */}
          </div>
        ))}
    </>
  );
};

export default Properties;
